import { FC, useRef } from 'react'
import { useInView } from 'framer-motion'

import { regions } from '../region-list'
import { Container, Link, Title } from './styled'

export const Article: FC<(typeof regions)[number]> = ({
  name,
  link,
  ...region
}) => {
  const ref = useRef<HTMLAnchorElement>(null)
  const isInView = useInView(ref, {
    margin: '-50% 0px -50% 0px',
    amount: 'some',
  })
  let inputLink = {}
  if (link) {
    inputLink = { href: link }
  }

  return (
    <Container {...region} key={name} $isInView={isInView}>
      <Link
        {...inputLink}
        /*href={link}*/
        ref={ref}
        $image={link ? region.image : region.imageInactive}
        $imageHover={link ? region.imageHover : region.imageInactiveHover}
      >
        <Title>{name}</Title>
      </Link>
    </Container>
  )
}
